module.exports = __webpack_public_path__ + "img/icon-ecosystem-light-blue.f9b59ea7.svg";